import React from "react";
import { SuggestionsBlockProps } from "../../types/searchResults";

/**
 * SuggestionsBlock - Stub component for search suggestions
 *
 * Displays suggested search queries (stub data for now).
 * Will be implemented with real suggestions in future iterations.
 */
const SuggestionsBlock: React.FC<SuggestionsBlockProps> = ({
  suggestions = [],
  className = "",
  onSuggestionClick,
}) => {
  const handleSuggestionClick = (suggestion: string) => {
    if (onSuggestionClick) {
      onSuggestionClick(suggestion);
    } else {
      console.log("Suggestion clicked:", suggestion);
    }
  };

  return (
    <div className={`suggestions-block ${className}`} style={styles.block}>
      <div style={styles.tags}>
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            onClick={() => handleSuggestionClick(suggestion)}
            style={styles.tag}
            aria-label={`Search for ${suggestion}`}
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
};

// Minimal inline styles
const styles = {
  block: {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    padding: "12px 8px",
  },
  title: {
    margin: "0 0 12px 0",
    fontSize: "16px",
    fontWeight: 600,
    color: "#334155",
  },
  tags: {
    display: "flex",
    flexWrap: "nowrap" as const, // убрали перенос
    gap: "12px",
    overflowX: "auto" as const, // горизонтальный скролл
    overflowY: "hidden" as const,
    whiteSpace: "nowrap" as const,
    paddingBottom: "4px", // чтобы скролл не прилипал
  },

  tag: {
    flex: "0 0 auto",
    padding: "8px 12px",
    backgroundColor: "#F2F3F5",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px !important",
    color: "#475569",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
};

export default SuggestionsBlock;
